import { SET_ATUALIZAR_DADOS_CADASTRAIS } from '../actions/actionTypes';

export const setAtualizarDadosCadastrais = (value) => ({
    type: SET_ATUALIZAR_DADOS_CADASTRAIS,
    newValue: value
});
